import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { FeatureFlagsProvider } from "@/feature_toggling/FeatureFlagsProvider";
import type { Channel } from "@/models/Channel";
import { WebComponentRuntimeProvider } from "./webComponentRuntimeContext";

interface WrapperProps {
  children?: React.ReactNode;
  backendHost?: string;
  appPathPrefix?: string;
  skipCart?: boolean;
  channel?: Channel;
  language?: string;
  enableInputAutoComplete?: boolean;
}

export const webComponentQueryClient = new QueryClient();

export default function Wrapper({
  children,
  backendHost,
  appPathPrefix,
  skipCart = false,
  channel,
  language,
  enableInputAutoComplete,
}: Readonly<WrapperProps>) {
  return (
    <React.StrictMode>
      <FeatureFlagsProvider
        flags={{
          enableInputAutoComplete: enableInputAutoComplete ?? false,
        }}
      >
        <WebComponentRuntimeProvider
          backendHost={backendHost}
          appPathPrefix={appPathPrefix}
          skipCart={skipCart}
          channel={channel}
          language={language}
        >
          <QueryClientProvider client={webComponentQueryClient}>
            {children}
          </QueryClientProvider>
        </WebComponentRuntimeProvider>
      </FeatureFlagsProvider>
    </React.StrictMode>
  );
}
